// const httpss = 'http://localhost:3003';
// const httpss = 'https://vivu.vhu.edu.vn';
const httpss = 'https://qr.myu.vn' || 'https://qr.hunghau.org'; //đang xài
// const httpss = 'https://dashboard-api.myu.vn'
// const httpss = '';


export {httpss};